import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import axios from 'axios'

import {RelatedContentResults} from './relatedcontentresults.component'
import {SearchFail} from '../searchfail.component'


const ACCOMMODATION_URL = '/api/v1/hotels/'
const DESTINATION_URL = '/api/v1/destinations/info/'
const ACTIVITY_URL = '/api/v1/attractions/'

export class RelatedContentBand extends React.Component {
    constructor(props) {
        super(props)

        // console.log('related content band')
        // console.log(props)


        let count = this.props.count ? this.props.count : 9

        this._params = {with: 'images', limit: count}
        this._relatedUrl = null
        this._itemId = null
        this._isMounted = false

        this.state = {
            isLoaded: false,
            hasError: false,
            showFail: this.props.showFail,
            results: null,
            destId: this.props.destId,
            item: this.props.item,
            type: this.props.type,
            model: this.props.model,
            leg: this.props.leg
        }

        _.bindAll(this,
            'getResults'
        )
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    componentDidMount() {
        this._isMounted = true
        this.getResults()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.item !== this.state.item || this.state.leg.get('id') !== nextProps.leg.get('id')) {
            this.setState({
                item: nextProps.item,
                type: nextProps.type,
                model: nextProps.model,
                leg: nextProps.leg,
                destId: nextProps.destId,
                showFail: nextProps.showFail,
                isLoaded: false,
                hasError: false,
                results: null
            })
            this.getResults()
        } else if (nextProps.leg.get('accommodations').size !== this.state.leg.get('accommodations').size) {
            // this passes down to related bands to hide any items that were removed from the list
            this.setState({
                leg: nextProps.leg,
            })
        } else if (nextProps.leg.get('activities').size !== this.state.leg.get('activities').size) {
            // this passes down to related bands to hide any items that were removed from the list
            this.setState({
                leg: nextProps.leg,
            })
        }
    }

    getRadius(bounds) {
        let lat1 = bounds.south
        let lon1 = bounds.west
        let lat2 = bounds.north
        let lon2 = bounds.east
        var p = 0.017453292519943295    // Math.PI / 180
        var c = Math.cos
        var a = 0.5 - c((lat2 - lat1) * p) / 2 +
            c(lat1 * p) * c(lat2 * p) *
            (1 - c((lon2 - lon1) * p)) / 2

        let diameter = 12742 * Math.asin(Math.sqrt(a))

        // if we're going to be 10km for the radius, let's bump it up a bit
        if (diameter < 20) {
            diameter = 50
        }

        if (diameter < 320 && this.state.model == 'destination') {
            diameter = 320
        }

        let result = Math.round(diameter / 2)
        return (isNaN(result) ? 10 : result) + 'km'
    }

    getResults() {
        if (this.state.destId) {
            let exclude = []
            // get any that were passed in
            // exclude.merge()

            switch (this.state.type) {
                case 'promoted':
                case 'similar':
                    switch (this.state.model) {
                        case 'accommodation':
                            this._relatedUrl = ACCOMMODATION_URL
                            this._itemId = this.state.item.get('id')
                            if (this.state.leg) {
                                this.state.leg.get('accommodations').map((accommodation) => {
                                    exclude.push(accommodation.get('id'))
                                })
                            }
                            break
                        case 'attraction':
                            this._relatedUrl = ACTIVITY_URL
                            this._itemId = this.state.item.get('place_id')
                            if (this.state.leg) {
                                this.state.leg.get('activities').map((activity) => {
                                    exclude.push(activity.get('place_id'))
                                })
                            }
                            break
                        case 'destination':
                            this._relatedUrl = DESTINATION_URL
                            this._itemId = this.state.destId
                            break
                    }
                    this._relatedUrl += this._itemId + '/similar/'
                    break
                default:
                    switch (this.state.model) {
                        case 'accommodation':
                            if (this.state.leg) {
                                this.state.leg.get('accommodations').map((accommodation) => {
                                    exclude.push(accommodation.get('id'))
                                })
                            }
                            break
                        case 'attraction':
                            if (this.state.leg) {
                                this.state.leg.get('activities').map((activity) => {
                                    exclude.push(activity.get('place_id'))
                                })
                            }
                            break
                        case 'destination':
                            this._params.skip = this.state.destId
                            break
                    }
                    this._params.type = this.state.model

                    // console.log("in here looking for related stuff")
                    // console.log(this.state.item)

                    let boundedRadius = this.state.item.getIn(['opencage', 'bounds']) ? this.getRadius(JSON.parse(this.state.item.getIn(['opencage', 'bounds']))) : null
                    if (boundedRadius != null) {
                        this._params.distance = boundedRadius
                    }
                    // else if(this.state.model === 'destination'){
                    //   this._params.distance = '100mi'
                    // }

                    this._relatedUrl = DESTINATION_URL + this.state.destId + '/near/'
                    break
            }

            // Add any ids we need to skip
            if (exclude.length > 0) {
                this._params.skip = exclude.join()
            }

            if (this._relatedUrl) {
                let self = this
                // Do our search
                axios.get(self._relatedUrl, {
                    params: self._params
                })
                    .then(function (response) {
                        // set the destination id
                        if (typeof response.data !== 'undefined') {
                            if (self._isMounted) {
                                self.setState({results: response.data.results, isLoaded: true})
                            }
                        }
                    })
                    .catch(function (error) {
                        console.log('Error getting related content')
                        console.log(error)
                        if (error.response) {
                            console.log(error.response.data)
                            if (typeof error.response.data != 'undefined' && typeof error.response.data.results != 'undefined') {
                                // set the destination id
                                // formattedChoice.id = error.response.data.data.id;
                                // TODO: not sure what this error is catching, if it errors do we have an id?
                            }
                        } else {
                            console.log('Error', error.message)
                        }
                        // set default choice with no identifier
                        // self.setState({ activeDestination: formattedChoice, isDestinationView: true})
                        // self.props.onSelectDestination(self.props.leg,formattedChoice)
                    })
            } else {
                if (this._isMounted) {
                    this.setState({hasError: true})
                }
            }
        } else {
            this.setState({isLoaded: true, results: []})
        }
    }

    render() {
        if (this.state.isLoaded && this.state.results.length > 0) {
            return <RelatedContentResults {...this.props} leg={this.state.leg} results={this.state.results}/>
        } else if (this.state.isLoaded && this.state.showFail) {
            return <SearchFail {...this.props} type={this.state.model}/>
        } else {
            return null // No results found. Still show anything?
        }
    }
}
